import { useState, useEffect } from "react";

import Board from "components/Meta/Board";
import requestView from "./ModelStockRequest";

const config = {
  mode: "barcode",
};

function StockRequest() {
  const [ctxView, setCtxView] = useState(null);

  useEffect(() => {
    requestView.ctxView(config).then(setCtxView);
  }, []);

  if (!ctxView) return null;

  return <Board ctxView={ctxView} />;
}

export default StockRequest;
